import { render, staticRenderFns } from "./AddUserExpansion.vue?vue&type=template&id=7ba274a7&scoped=true&functional=true&"
import script from "./AddUserExpansion.vue?vue&type=script&lang=js&"
export * from "./AddUserExpansion.vue?vue&type=script&lang=js&"
import style0 from "./AddUserExpansion.vue?vue&type=style&index=0&id=7ba274a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7ba274a7",
  null
  
)

export default component.exports